import {
  Alert,
  Box,
  Checkbox,
  FormControlLabel,
  TextField,
} from "@mui/material";
import PageTitleSubtitle from "../PageTitleSubTitle";
import localize from "../../common/localize";
import { getInputLabelProps, getInputProps } from "../../common/appStyles";

export default function NotificationSetup({
  entity,
  setEntity,
  subtitle,
  showOnlyDefinedToUser,
}) {
  const handleChange = (e) => {
    setEntity({
      ...entity,
      [e.target.name]:
        e.target.name === "createNotification" ||
        e.target.name === "onlyToDefinedUser"
          ? e.target.checked
          : e.target.value,
    });
  };

  return (
    <Box className="w-full flex flex-col gap-2">
      <FormControlLabel
        size="small"
        name="createNotification"
        control={
          <Checkbox
            size="small"
            name="createNotification"
            checked={entity.createNotification ?? false}
            onChange={handleChange}
          />
        }
        label={
          <span style={{ fontSize: "0.8em" }}>
            <PageTitleSubtitle
              title={localize.notification}
              subtitle={subtitle}
              useEventTitleStyle
              useFieldTitleStyle
            />
          </span>
        }
      />

      {entity?.createNotification && (
        <div className="w-full flex flex-col gap-2">
          <Alert className="w-full" severity="info">
            <label className="text-xs">{localize.user_to_notify_note}</label>
          </Alert>

          <TextField
            required
            InputLabelProps={getInputLabelProps()}
            inputProps={getInputProps()}
            size="small"
            fullWidth
            multiline
            rows={4}
            id="outlined-basic"
            name="notifyToUserName"
            label={localize.users}
            variant="outlined"
            onChange={handleChange}
            value={entity.notifyToUserName ?? ""}
          />

          {showOnlyDefinedToUser && entity.notifyToUserName?.length > 0 && (
            <FormControlLabel
              size="small"
              name="onlyToDefinedUser"
              control={
                <Checkbox
                  size="small"
                  name="onlyToDefinedUser"
                  checked={entity.onlyToDefinedUser ?? false}
                  onChange={handleChange}
                />
              }
              label={
                <span style={{ fontSize: "0.8em" }}>
                  <PageTitleSubtitle
                    title={localize.notify_only_defined_user}
                    useEventTitleStyle
                    useFieldTitleStyle
                  />
                </span>
              }
            />
          )}
        </div>
      )}
    </Box>
  );
}
